<template>
    <p class="block font-medium text-sm text-red-700 mt-1" v-html="message"></p>
</template>

<script>
    export default {
        props: ['message']
    }
</script>
